import template from "./pApi.html";

const IP_REGEX = /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/;
const IP_WITH_RANGE_REGEX = /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}\/([0-9]|[1-2][0-9]|3[0-2])$/;

export function pApiDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pApiController,
    controllerAs: 'pApi',
    bindToController: true
  };

  return directive;
}

const API_KEYS = [
  "sites",
  "teams",
  "users",
  "processGroups",
  "processes",
  "interrupts",
  "clientGroups",
  "clients",
  "processClientConfigurations",
  "income",
  "worklogs",
  "projects"
];

class pApiController {
  constructor(Auth, Admin, $scope, Notes, $interval, bModal, ConnectionQuality) {
    'ngInject';

    this.Auth = Auth;
    this.Admin = Admin;
    this.$scope = $scope;
    this.$interval = $interval;
    this.Notes = Notes;
    this.bModal = bModal;
    this.ConnectionQuality = ConnectionQuality;

    this.init();

    this.fields = {
      name: "name"
    };

    this.globalActions = [
      {
        name: "add",
        functionName: "startAddinNewVendor",
        fa: "fa-plus"
      }
    ];

    this.rowActions = [
      {
        name: "regenerate",
        functionName: "regenerateApiKeys",
        fa: "fa-pencil-alt"
      },
      {
        name: "edit",
        functionName: "startEditingVendor",
        fa: "fa-pencil-alt"
      },
      {
        name: "delete",
        functionName: "startDeletingVendor",
        fa: "fa-trash"
      }
    ];

    /*
    * b-dialog-card data
    */

    this.vendorData = {
      name: {
        type: "text",
      },
      emailAddress: {
        type: "text",
      },
      ipAddresses: {
        type: "myInput",
        tooltip: true
      },
      ipAddressesRanges: {
        type: "ipAddressesRanges",
        tooltip: true
      }
    };

    API_KEYS.map( key => {
      this.vendorData[key] = {type: "checkbox", isNotRequired: true};
    });

    this.deleteVendorData = {
      name: {
        type: "text",
      }
    };

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  init() {
    this.state = 'loading';
    this.Auth.authorizeAdmin().then(
      (user) => {
        this.user = user;
        if (!this.user.isAdmin) {
          if (!this.user.isLocalAdmin)
            this.Auth.handleUnauthorized();
        }

        this.state = 'loaded';
        this.Admin.getVendors().then(
          (success) => {
            this.vendors = success.data.sort((a,b) => a.name.localeCompare(b.name));
            this.state = 'loaded';
          },
          (error) => {
            this.state = 'loaded';
            this.Notes.postNote({type: "error", error: error});
          }
        );

        var timeout = this.$interval(() => {
          this.notes = this.Notes.getNotes();
        }, 10);
        this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout);});
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );
  }

  startAddinNewVendor() {
    this.newVendorProcess = true;
    this.newVendorValues = null;
    this.newVendorValues = {
      ipAddresses: [""],
      ipAddressesRanges: [""]
    };
  }

  endpoints(data) {
    let checkedKeysObj = angular.copy(data);
    delete checkedKeysObj.name;
    delete checkedKeysObj.emailAddress;
    delete checkedKeysObj.ipAddresses;
    delete checkedKeysObj.ipAddressesRanges;
    delete checkedKeysObj.id;

    const checkedKeys = Object.keys(checkedKeysObj).reduce((accum, curr) => {
      checkedKeysObj[curr] && accum.push(curr);
      return accum;
    },[]);

    let endpoints = {};
    API_KEYS.map( key => checkedKeys.find( t => t == key ) ? endpoints[key] = true : endpoints[key] = false );

    return endpoints;
  }

  addVendor(form_data) {
    if (this.state == 'loading')
      return;

    const validationErrors = [];

    let dto = {
      name: form_data.name,
      emailAddress: form_data.emailAddress,
      ipAddresses: form_data.ipAddresses.map( a => a.replace(' ', '') ).filter( a => a !== ''),
      ipAddressesRanges: form_data.ipAddressesRanges.map( a => a.replace(' ', '') ).filter( a => a !== ''),
      endpoints: this.endpoints(form_data)
    };

    dto.ipAddresses.forEach( ip => {
      const match = IP_REGEX.test(ip);

      if (!match)
        validationErrors.push('Invalid IP address - ' + ip);
    });

    dto.ipAddressesRanges.forEach( ip => {
      const match = IP_WITH_RANGE_REGEX.test(ip);

      if (!match)
        validationErrors.push('Invalid IP address range - ' + ip);
    });

    if (validationErrors.length > 0) {
      this.Notes.postNote({type: "error", error: { data: validationErrors }});
      return;
    }

    this.state = 'loading';

    this.Admin.setVendor(dto).then(
      () => {
        this.newVendorProcess = false;
        this.newVendor = null;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  startEditingVendor(form_data) {
    const endpoints = form_data.endpoints;
    let editVendorValues = angular.copy(form_data);
    delete editVendorValues.endpoints;
    API_KEYS.map( key => {
      endpoints[key] ?
        editVendorValues[key] = true :
        editVendorValues[key] = false;
    });

    this.editVendorProcess = true;
    this.editVendorValues = editVendorValues;

    if (this.editVendorValues.ipAddresses.length === 0)
      this.editVendorValues.ipAddresses[0] = "";

    if (this.editVendorValues.ipAddressesRanges.length === 0)
      this.editVendorValues.ipAddressesRanges[0] = "";
  }

  updateVendor(form_data) {
    if (this.state == 'loading')
      return;

    const validationErrors = [];

    let dto = {
      name: form_data.name,
      emailAddress: form_data.emailAddress,
      ipAddresses: form_data.ipAddresses.map( a => a.replace(' ', '') ).filter( a => a !== ''),
      ipAddressesRanges: form_data.ipAddressesRanges.map( a => a.replace(' ', '') ).filter( a => a !== ''),
      endpoints: this.endpoints(form_data)
    };

    dto.ipAddresses.forEach( ip => {
      const match = IP_REGEX.test(ip);

      if (!match)
        validationErrors.push('Invalid IP address - ' + ip);
    });

    dto.ipAddressesRanges.forEach( ip => {
      const match = IP_WITH_RANGE_REGEX.test(ip);

      if (!match)
        validationErrors.push('Invalid IP address range - ' + ip);
    });

    if (validationErrors.length > 0) {
      this.Notes.postNote({type: "error", error: { data: validationErrors }});
      return;
    }

    this.state = 'loading';

    this.Admin.updateVendor(form_data.id, dto).then(
      () => {
        this.editVendorProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  startDeletingVendor(vendor) {
    this.deleteVendorProcess = true;
    this.deleteVendorValues = vendor;
  }

  deleteVendor(vendor) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    this.Admin.deleteVendor(vendor.id).then(
      () => {
        this.deleteVendorProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  regenerateApiKeys(vendor) {

    this.modalConfig = {
      text: "API.CONFIRMATION",
      cancelText: "CANCEL",
      acceptText: "SUBMIT"
    };

    this.bModal.show(this.modalConfig).then(
      () => {
        this.Admin.regenerateApiKeys(vendor.id).then(
          () => {
            this.state = 'loaded';
            this.Notes.postNote({type: "success"});
          },
          (error) => {
            this.state = 'loaded';
            this.Notes.postNote({type: "error", error: error});
          }
        );
      },
      () => {
        // CANCEL action
      }
    );

  }

  addIpAddress(addresses) {
    addresses.push("");
  }
}
